import { CandidateFormPage } from "~/pages/CandidateFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/candidates/create")({
  component: RouteComponent,
});

function RouteComponent() {
  useBreadCrumbs([
    { title: "Candidates", link: `/${location.pathname.split("/")[1]}/data/candidates` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/candidates/create` },
  ]);
  return <CandidateFormPage />;
}
